import { State } from '../State';
import { Locale } from '../ruleset/locale';
import { duration } from '../utils/duration';

/**
 * Get current player locale
 */
export function getLocale(state: {
  settings: Pick<State['settings'], 'locale'>;
}): Locale {
  if (state.settings.locale === '') return 'ja';
  return state.settings.locale as Locale;
}
